<template>
  <div>
     <div class="loading" v-if="id && !renderData.titleImg"> 加载中... </div>
    <div class="main" :style="'background:' + (renderData.backColor || '#53AEBF') + ';'" >
      <div class="banner-box">
        <img class="banner" :src="id
              ? renderData.titleImg
              : 'https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20200910095324929-drive_h5_toppic@3x.jpg'
          " alt="" />
      </div>
      <div class="gac-main">
        <div class="form">
          <div class="item" v-for="item in extJsonArray" :key="item.fieldCode" v-show="item.showStatus===1" >
             <!-- 填空  -->
            <template v-if="item.fieldStatus===0 && item.fieldCode!=='phone'">
              <div class="label">{{item.fieldName}}</div>
              <div class="input-box">
                <input
                  :data-growing-title="item.fieldName"
                  type="text"
                  class="input"
                   :maxlength="item.fieldCode==='userName'?20:25"
                  v-model="item.fieldValue"
                  @input="onInput($event, item.fieldCode)"
                  :placeholder="item.remark"
                />
              </div>
            </template>
            <template v-if="item.fieldStatus===0 && item.fieldCode==='phone'">
              <div class="label">{{item.fieldName}}</div>
              <div class="input-box">
                <input
                  :data-growing-title="item.fieldName"
                  maxlength="11"
                  type="tel"
                  class="input"
                  v-model.number="item.fieldValue"
                  @input="onInput($event, item.fieldCode)"
                  :placeholder="item.remark"
                />
              </div>
            </template>
            <!-- 城市下拉框  -->
            <template v-if="item.fieldStatus===1">
              <div class="label">{{item.fieldName}}</div>
              <div class="input-box" :data-growing-title="item.fieldName">
                <city-picker
                  :max-width="isPC ? 750 : null"
                  ref="cityPicker"
                  :value="address"
                  @address-input="getCity"
                />
              </div>
            </template>
           
          </div>
          <div
            class="btn"
            :style="'background:' + (renderData.buttonColor || '#00B9EF') + ';'"
            data-growing-title="提交按钮"
            @click="submit" >
            {{ renderData.buttonName || "确定" }}
          </div>
        </div>
      </div>

      <div class="rule">
        <img :src="id?renderData.bottomImg:'https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20200909155913224-drive_h5_suv%403x.png'" alt="" />
      </div>
      <div class="floor"></div>
      <show-tips ref="showTips"></show-tips>
      <div
        class="model"
        :class="{ show: show }"
        @click="closePopup"
        @touchmove.prevent
      >
        <div class="model-main" @click.stop="stop">
          <img :src="renderData.toastImg||'https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20200925133800977-success.png'" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/libs/axios.js";
import util from "@/common/util.js";
import CityPicker from "../../components/city-picker";
import showTips from "@/components/showTips/showTips.vue";
import WXShare from "@/mixins/new";
export default {
  name: "gatherResources",
  components: { showTips, CityPicker },
  mixins: [WXShare()],
  data() {
    let vm = this;
    return {
      isPC: (function() {
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array(
          "Android",
          "iPhone",
          "SymbianOS",
          "Windows Phone",
          "iPad",
          "iPod"
        );
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      })(),
      form: {},
      cityObject: {},
      renderData: {},
      extJsonArray:[],
      address:[],
      id:'',
      show: false
    };
  },
  mounted() {
    let id = util.jsUrlHelper.getUrlParam(window.location.href, "id");
    this.id = id
    if (id) {
      this.form.channelId = id;
      this.getConfigById(id)
        .then(res => {
          let result = res.data.data;
          window.document.title = result.wxTitle;
          if (result.hasAddress === 1) {
            this.form.address = "";
          }
          if (result.hasUsername === 1) {
            this.form.userName = "";
          }
          if (result.hasPhone === 1) {
            this.form.phone = "";
          }
          if (result.hasExt === 1) {
            this.form.ext = "";
          }
          if (result.hasCity === 1) {
            this.form.cityCode = "";
            this.form.cityName = "";
            this.form.provinceCode = "";
            this.form.provinceName = "";
          }
          this.renderData = result;
          this.extJsonArray = JSON.parse(JSON.stringify(result.extJsonArray));
          if (result.type !== 2) {
            this.$refs.showTips.showTips("您访问的页面有误！即将离开");
            setTimeout(() => {
              window.location.href = "https://www.hycan.com.cn/";
            }, 2000);
          }

          //console.log(6666, result, this.form);
        })
        .catch(_ => {
          this.$refs.showTips.showTips("您访问的页面有误！即将离开");
          setTimeout(() => {
            window.location.href = "https://www.hycan.com.cn/";
          }, 2000);
        });
    }else{
      let result = { hasUsername:1, hasPhone:1, };
      this.form.channelId = 0;
         if (result.hasUsername === 1) {
            this.form.userName = "";
          }
          if (result.hasPhone === 1) {
            this.form.phone = "";
          }
      this.renderData = result;
    }
  },
  methods: {
    getConfigById(id) {
      return axios({
        method: "get",
        url: `/marketing/channelCodingConfiguration/noAuth/front/v3.2.4/getFrontById?id=${id}`,
        data: {},
        headers: {
          Authorization: "null",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
    },
  
    onInput(ev, key) {
      let value = ev.target.value;
      this.form[key] = value;
    },
    getCity(e) {
       this.address = e
       this.cityObject = {
        provinceCode:e[0].nodeCode,
        cityCode:e[1].nodeCode,
        provinceName:e[0].nodeName,
        cityName:e[1].nodeName,
      }
      this.form.provinceCode = e[0].nodeCode;
      this.form.cityCode = e[1].nodeCode;
      this.form.provinceName = e[0].nodeName;
      this.form.cityName = e[1].nodeName;
    },
    bodyScroll(event) {
      event.preventDefault();
    },
    showPopup() {
      this.show = true;
    },
    closePopup() {
      this.show = false;
    },
    stop() {},
    postMessage(data) {
      return axios({
        method: "post",
        url: `/marketing/retainCapital/noAuth/front/v3.2.4/addRetainCapital`,
        data: data,
        headers: { Authorization: "" }
      });
    },
    formatForm(){
      let data = {
        extJsonArray:this.extJsonArray,
        ...this.form
      }
      data.extJsonArray.map(el=>{
        if(el.fieldCode==="city" && el.fieldStatus===1){
          el.cityObject = this.cityObject
        }
      })
      return data
    },
    submit() {
      let data = this.formatForm()
      //console.log(33333,data);
      let isFill = true;
      Object.keys(data).map(key => {
        if (!data.userName && !data.phone) {
          this.$refs.showTips.showTips("请先填写信息，以便我们联系你");
          isFill = false;
        }
        if (key === "phone" && !data[key] && /^\d{0,11}$/g.test(data[key])) {
          this.$refs.showTips.showTips("请输入正确的手机号码");
          isFill = false;
        }
      });
      if (!isFill) { return false; }

      this.postMessage(data)
        .then(res => {
          if (res.data.code === 0) {
            //console.log(233, res.data);
            this.showPopup();
            
            Object.keys(this.cityObject).map(key => (this.cityObject[key] = ""));
            Object.keys(this.form).map(key => (this.form[key] = ""));
            this.$set(this,'extJsonArray',this.renderData.extJsonArray)
            this.form.channelId = this.id;
            this.$set(this,'address',[])
          } else {
            this.$refs.showTips.showTips(res.data.msg || "报名失败！");
          }
        })
        .catch(err => {
          //console.log(err);
          this.$refs.showTips.showTips(err.msg || "网络异常");
        });
    }
  }
};
</script>

<style lang="scss">
@import '@/common/scss/_themes.scss';
@import "~@/common/flexible";
body {
  // background-color: #53aebf;
}
.loading {
  margin-top: 60px;
  font-size: 28px;
  color: #181a24;
  text-align: center;
  width: 100%;
}
.main {
  // padding-bottom: 60px;
  // background: #53aebf;
  //   url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20200828160619102-h5_0yuan_toppic@3x.jpg)
  //   no-repeat center top/100% auto;
}
.banner-box {
  width: 100%;
  z-index: -1;
  min-height: 100px;
}
.banner {
  width: 100%;
  height: auto;
  display: block;
}
.gac-main {
  position: relative;
  z-index: 10;
  margin-top: -108px;
  padding-bottom: 30px;
}
.form {
  margin: 0 30px 0;
  padding: 10px 40px 60px;
  background: white;
  border-radius: 20px;
}
.item {
  padding: 32px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
}
.label {
    width: 165px;
    flex-shrink: 0;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #181a24;
    font-size: 30px;
    line-height: 1;
    vertical-align: middle;
}
.input-box {
  flex: 1;
}
.input {
  background-color: #fff;
  border: none;
  font-size: 30px;
  margin: 0;
  padding: 0;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #181a24;
  line-height: 39px;
  height: 39px;
  width: 100%;
  appearance: none;
  display: block;
}
.input::placeholder {
  font-size: 30px;
  color: #ccc;
  line-height: 39px;
}
.input:focus {
  border: 0;
  outline: none;
}
.btn {
  @include fontButton(88px);
  margin-top: 60px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
}
.rule {
  margin: 30px 30px 0;
  padding: 0;
  overflow: hidden;
  background: white;
  border-radius: 20px;
  color: rgba(24, 26, 36, 1);
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.rule-title {
  font-size: 32px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #181a24;
  line-height: 40px;
  font-weight: bold;
  text-align: center;
}
.rule-item {
  margin-top: 32px;
  font-size: 28px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #181a24;
  line-height: 40px;
}
.floor {
  margin: 0 auto;
  padding: 50px 0 50px;
  width: 690px;
  // height: 29px;
  background: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20200828160619079-h5_0yuan_slogan_pic@3x.png)
    no-repeat center center/contain;
}
.model {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: 0.2s ease-in all;
}
.model.show {
  opacity: 1;
  visibility: visible;
}
.model-main {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 540px;
  padding: 0;
  overflow: hidden;
  background-color: transparent;
  border-radius: 20px;
  box-sizing: border-box;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.model-icon {
  margin: 0 auto;
  width: 60px;
  height: 60px;
  background: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20200612102614672-signinsuccessfully_icon_chenggong%403x.png)
    no-repeat center center/contain;
}
.model-success-text {
  margin-top: 30px;
  text-align: center;
  font-size: 36px;
  font-family: PingFangSC-Regular;
  font-weight: 600;
  color: $themeColorGreen;
  line-height: 56px;
}
.model-desc {
  margin-top: 12px;
  font-size: 28px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #051c2c;
  line-height: 40px;
  text-align: center;
}
.model-title {
  margin: 0 -40px;
  position: relative;
  margin-top: 60px;
  font-size: 30px;
  font-family: PingFangSC-Medium;
  font-weight: bold;
  color: #181a24;
  line-height: 42px;
  text-align: center;
}
.model-title::after {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 160px;
  height: 2px;
  background-color: #eee;
}
.model-title::before {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 160px;
  height: 2px;
  background-color: #eee;
}
.model-content,
.model-contact {
  font-size: 28px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #181a24;
  line-height: 44px;
}
.model-content {
  margin-top: 25px;
}
.model-contact {
  margin-top: 50px;
}
.model-tips {
  margin-top: 60px;
  font-size: 28px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: $themeColor;
  line-height: 34px;
  text-align: center;
}
</style>
